<template>
    <div>
        <el-dialog
            title="ยกเลิก Notify"
            :visible.sync="dialogVisible"
            width="30%"
            :close-on-click-escape="false"
            :close-on-click-modal="false"
             @closed="onHidden"
            :before-close="onHidden"
            custom-class="loadindNotifyCancel"
            center>
            <p><b>ticketPickupId : {{detail.ticketPickupId}}</b></p>
            <p>ชื่อร้าน : {{detail.srcName}}</p>
            <p>Address : {{detail.srcDetailAddress}}</p>
            <p>Province : {{detail.srcProvinceName}}</p>
            <p>District : {{detail.srcDistrictName}}</p>
            <p>City : {{detail.srcCityName}}</p>
            <p>postalCode : {{detail.postalCode}}</p>
            <p>phone : {{detail.phone}}</p>
            <p>stateText : {{detail.stateText}}</p>

             <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                <el-button type="primary" @click="cancelNotify" >ยืนยัน</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'NotifyCancel',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        notifyDetail: {
            type: Object,
            default: null
        }

    },
    data () {
        return {
            dialogVisible: false,
            countOrder: null,
            detail: {},
            remark: ''
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                this.dialogVisible = true
            }
        },
        notifyDetail (val) {
            if (val) {
                this.detail = { ...val }
                console.log(this.detail)
            }
        }
    },
    methods: {
        onHidden (done) {
            this.$emit('closeModal')
            if (done !== undefined) {
                done()
            }
        },
        async cancelNotify () {
            let loadingAddUser = this.$loading({
                target: '.loadindNotifyCancel',
                text: 'กำลังบันทึก...'
            })

            try {
                let param = {
                    ticketPickupId: parseInt(this.detail.ticketPickupId)
                }
                let resNotify = await fgApi.courier.cancelNotify(param)
                if (resNotify.success) {
                    this.$message({ type: 'success', message: 'บันทึกข้อมูลเรียบร้อยแล้ว' })
                    this.dialogVisible = false
                    this.$emit('closeModal')
                    this.$emit('closeModalRefresh')
                } else {
                    this.$message.error(resNotify.message)
                }
            } catch (error) {
                console.log(error)
                this.$message.error('Oops !, Api is error.')
            }
            loadingAddUser.close()
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
